import styled from 'styled-components';
import { colors } from '../colorCodes';

export const Icon = styled.i`
    display: inline-block;
    position: ${props => props.position};
    background-image: url(${props => props.url});
    background-repeat: ${props => props.repeat || 'no-repeat'};
    background-size: ${props => props.size || '10px'};
    background-position: ${props => props.position || '10px 10px'};
    width: ${props => props.width || '30px'};
    height: ${props => props.height || '25px'};
    font-size: ${props => props.fontSize || '30px'};
    color: ${props => props.color || colors.inputBorder};
    top: ${props => props.top || '30px'};
    right: ${props => props.right || '30px'};
    left: ${props => props.left};
    font-weight: ${props => props.fontWeight || 'normal'};
    cursor: ${props => props.cursor || 'default'};
    &:before {
        content: ${props => `${props.content} !important`};
    }
`;

export default Icon;
